export enum AggregatorsRoutesEnum {
  root = 'aggregators',
  main = '',
  details = 'details',
  provider = 'provider',
}
